import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Container from '@material-ui/core/Container';
import CardMedia from '@material-ui/core/CardMedia';
import FormControl from '@material-ui/core/FormControl';
import Logo from '../../../assets/Login_logo.png';
import Background from '../../../assets/Background.jpg';
import { CommonConfig } from '../../../config/common-config';
import PrivacyFooter from '../footer';

// for dev ENV:
// let host = 'itec.maveric-systems.com/login';
// let host = 'advith.maveric-systems.com/login';

// for Pre-prod ENV:
// let host = 'itec.itecapp.in/login';
// let host = 'advith.itecapp.in/login';
// let host = 'api.itecapp.in/login';

// for prod ENV:
// let host = 'itec.advithitec.in/login';
// let host = 'advith.advithitec.in/login';
// let host = 'api.advithitec.in/login';

let host = window.location.host;
console.log("'host'", host);

// let href = window.location.href;
//console.log("'href'", href);

// let protocol = window.location.protocol;
//console.log("'protocol'", protocol);

// let hostname = window.location.hostname;
//console.log("'hostname'", hostname);

// let pathname = window.location.pathname;
//console.log("'pathname'", pathname);

// let port = window.location.port;
//console.log("'port'", port);

let subDomainName = host.split('.')[0];
console.log("'subDomainName'", subDomainName);

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: '5% 10% 10% 10%',
        borderRadius: '10px',
        marginBottom: '75px',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    radiobtnmainDiv: {
        width: '100%',
    },
    radioGroupDiv: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        fontFamily: 'Rubik',
    },
    media: {
        width: '35%',
        paddingTop: '0%',
        paddingBottom: '0%',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    alignleft: {
        textAlign: 'left',
        marginBottom: '10px',
    },
    inputSelect: {
        border: '1px solid #ccc',
        width: '100%',
        borderRadius: '4px',
        padding: '10px 14px',
    },
    errorDiv: {
        color: 'red',
        fontSize: '0.8rem',
        paddingLeft: '5px',
    },

    fullWidth: {
        width: '100%',
    },
    fullWidthmobile: {
        width: '100%',
    },
    bgImage: {
        width: '100%',
        backgroundImage: `url(${Background})`,
        backgroundSize: 'cover',
        // height: '100%',
    },
    send: {
        margin: theme.spacing(3, 0, 2),
        background: '#f8961d',
        '&:hover': {
            background: '#fdac48',
        },
        border: '1px solid #ef8400',
        borderRadius: '5px',
        fontFamily: 'Rubik',
        width: '50%',
    },
    submit: {
        height: '46px',
        boxShadow: 'none !important',
        marginTop: '30px !important',
    },
    centerAlign: {
        textAlign: '-webkit-center',
    },
    success: {
        fontFamily: 'Rubik',
        color: 'green',
        fontSize: '14px',
        fontWeight: '600',
    },
    error: {
        fontFamily: 'Rubik',
        color: 'red',
        fontSize: '14px',
        fontWeight: '600',
    },
    fontRubik: {
        fontFamily: 'Rubik !important',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '10px 25px',
        letterSpacing: 'normal',
        backgroundColor: '#504cad !important',
        boxShadow: 'none !important',
        marginTop: '30px !important',
    },
    logo: {
        width: '100%',
        height: '100px',
    },
    scroll: {
        maxHeight: 'auto',
        minHeight: '100vh',
    },
    overflowHidden: {
        overflowY: 'hidden',
    },
}));

function ForgotPassword(props) {
    const classes = useStyles();
    const [emailDiv, setemailDiv] = useState('block');
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [IMCLogo, setIMCLogo] = useState('');

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Email Required'),
        }),
        onSubmit: (values) => {
            setShowBtnLoader(true);
            const data = {
                userName: values.email,
                tennantName: subDomainName,
            };
            return axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/forgot-password`, data)
                .then((result) => {
                    if (result.data) {
                        setShowBtnLoader(false);
                        setError('');
                        setSuccess('Please check your Email for password');
                    }
                })
                .catch(() => {
                    setShowBtnLoader(false);
                    setError('Please try with valid inputs');
                });
        },
    });

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-imc-logo/${subDomainName}`)
            .then((response) => {
                setIMCLogo(response.config.url);
            })
            .catch((err) => {});
    }, []);

    return (
        <div className={classes.bgImage}>
            <div className={classes.scroll}>
                <Container component="main" maxWidth="sm" className={classes.overflowHidden}>
                    <CssBaseline />
                    <div className={classes.paper}>
                        <CardMedia className={classes.media}>
                            <img src={IMCLogo} alt="logo" className={classes.logo} />
                        </CardMedia>
                        <Typography variant="subtitle1" gutterBottom className="forgotpass">
                            Please fill the details below to receive temporary password
                        </Typography>
                        <div className="main-container w100">
                            <div className={classes.fullWidth}>
                                <form className="w100" onSubmit={formik.handleSubmit}>
                                    <div className={classes.selectmainDiv} style={{ display: emailDiv }}>
                                        <div className="mt30" />
                                        <div className="mt30" />
                                        <FormControl fullWidth>
                                            <InputLabel className="lbl" htmlFor="email" shrink>
                                                Email Address
                                            </InputLabel>

                                            <Input
                                                className="bottom"
                                                fullWidth
                                                id="email"
                                                label="Email Address"
                                                name="email"
                                                autoComplete="email"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.email}
                                                placeholder="Enter Email"
                                            />
                                            {formik.touched.email && formik.errors.email ? (
                                                <span className={classes.errorDiv}>{formik.errors.email}</span>
                                            ) : null}
                                        </FormControl>
                                    </div>
                                    <div className={classes.centerAlign}>
                                        {(showBtnLoader && (
                                            <Button className={classes.submit} variant="outlined" fullWidth disabled>
                                                <CircularProgress color="primary" size={24} />
                                            </Button>
                                        )) || (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{ display: emailDiv }}
                                                type="submit"
                                                fullWidth
                                                className={classes.button}
                                            >
                                                Send
                                            </Button>
                                        )}

                                        <span className={classes.success}>{success}</span>
                                        <span className={classes.error}>{error}</span>
                                    </div>
                                </form>
                            </div>
                            <div className="mt15">
                                <Link to="/login" className="forgotpass" variant="body2" style={{ textDecoration: 'underline' }}>
                                    Back to Login
                                </Link>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            {/* <div className="btmMenu">
                <div className="btmLogo">
                    <img src={Logo} alt="logo" className={classes.logo} />
                </div>
                <div className="btmLogin">
                    <ul className="displayInline">
                        <li>&#169; Copyright 2021 Advith ITeC</li>
                        <li>Privacy Policy</li>
                        <li>Contact Us</li>
                        <li>Terms and Condition</li>
                    </ul>
                </div>
            </div> */}
            <PrivacyFooter />
        </div>
    );
}
export default ForgotPassword;
